'use client';

declare global {
  interface Window {
    leia?: {
      leid?: string | undefined;
    };
  }
}

export function getLeiaDeviceId() {
  if (!global?.window) return;

  return window?.leia?.leid;
}

// Add whatever values leia needs to send to backend
export function leiaApiPayload() {
  const leid = getLeiaDeviceId();

  if (leid) {
    return {
      leia_device_id: leid,
      le_repo: 'lovevery-next',
    };
  }

  return {
    le_repo: 'lovevery-next',
  };
}
